<div class="action-from-header">
    <span>{{ formStep === 1 ? 'Add New Action' : action.actionTypeName }}</span>
    <div
        *ngIf="showHeaderBtn && formStep === 2"
        class="header-btn-holder">
        <button class="btn-styled btn-styled--secondary">
            Convert
            <svg-icon
                class="--suffix"
                [svgClass]="'icon--button'"
                src="assets/images/icon-convert.svg"></svg-icon>
        </button>
    </div>
</div>
<div class="action-from-body">
    <div *ngIf="formStep === 1">
        <form
            [formGroup]="form"
            class="first-step-form">
            <div
                class="common-part-of-action-form"
                *yssIsLoading="step1Loading">
                <div class="select-action-group-holder">
                    <label class="padded-top-gray-label">Action Template:</label>
                    <ng-select
                        formControlName="selectedGroupId"
                        [clearable]="false"
                        [searchable]="false"
                        placeholder="Enter Action Template:"
                        (change)="onGroupSelected()">
                        <ng-option
                            [value]="group.id"
                            *ngFor="let group of groups">
                            {{ group.name }}
                        </ng-option>
                    </ng-select>
                </div>
                <div class="select-action-type-holder">
                    <label class="padded-top-gray-label">Template Type:</label>
                    <ng-select
                        formControlName="actionType"
                        [clearable]="false"
                        [searchable]="false"
                        placeholder="Enter Template Type:">
                        <ng-option
                            [value]="type.id"
                            *ngFor="let type of types">
                            {{ type.name }}
                        </ng-option>
                    </ng-select>
                </div>
            </div>
        </form>
    </div>
    <div *ngIf="formStep === 2">
        <form [formGroup]="form">
            <div class="common-part-of-action-form">
                <div
                    class="action-label-row"
                    *ngIf="action.actionTypeLabel">
                    <img
                        class="action-icon"
                        src="assets/images/icon-action-label.svg" />
                    <span class="text-label">Action Label:</span>
                    <div class="action-label-chip">
                        {{ action.actionTypeLabel }} {{ action.id ? ' - ' + action.id : '' }}
                    </div>
                </div>
                <div class="select-action-person-holder">
                    <img
                        class="action-icon"
                        src="assets/images/icon-add-admin.svg" />
                    <span class="text-label">Assigned Admin:</span>
                    <span
                        *ngIf="!selectedAdmin"
                        class="add-admin-button"
                        (click)="showSelectAdminDlg()"
                        ><img src="assets/images/icon-plus.svg" />&nbsp;Add Admin
                    </span>
                    <div
                        *ngIf="selectedAdmin"
                        class="selected-admin">
                        <div class="selected-admin-avatar-holder">
                            <app-avatar
                                [user]="selectedAdmin"
                                [fontSize]="8"
                                [showIcons]="false"></app-avatar>
                        </div>
                        <span class="selected-admin-name"
                            >{{ selectedAdmin.contact.firstname }} {{ selectedAdmin.contact.surname }}</span
                        >
                        <img
                            class="remove-selection-icon"
                            (click)="removeAdmin()"
                            src="/assets/images/chat/chip-remove-icon.svg" />
                    </div>
                </div>
                <div class="action-label-row">
                    <img
                        class="action-icon"
                        src="assets/images/icon-timer.svg" />
                    <span class="text-label">Completion Time:</span>
                    <div
                        *ngIf="!action?.completionTime"
                        class="add-completion-time-button">
                        <div (click)="this.showDateTimePicker = true">
                            <img src="assets/images/icon-plus.svg" />&nbsp;Add Date & Time
                        </div>
                        <div class="datetime-picker-holder">
                            <app-datetime-picker
                                *ngIf="showDateTimePicker"
                                (applied)="datetimeSelected($event)"
                                (canceled)="closeDatePicker()"></app-datetime-picker>
                        </div>
                    </div>

                    <div
                        *ngIf="action?.completionTime"
                        class="action-completion-time-chip">
                        <span>{{ action.completionTime | date : 'dd/MM/yyyy, HH:mm a' }}</span>
                        <img
                            class="remove-selection-icon"
                            (click)="removeCompletionTime()"
                            src="/assets/images/chat/chip-remove-icon.svg" />
                    </div>
                </div>
            </div>

            <div class="action-form-holder">
                <app-default-action-form
                    *ngIf="action.actionTypeLabel === ActionTypeLabel.ENQ || !action.actionTypeLabel"
                    [subFormIsLoading$]="subFormIsLoading$"
                    [action]="action"
                    [form]="form"></app-default-action-form>

                <app-callback-request-action-form
                    *ngIf="action.actionTypeLabel === ActionTypeLabel.CALL_REQ"
                    [subFormIsLoading$]="subFormIsLoading$"
                    [action]="action"
                    [form]="form"></app-callback-request-action-form>

                <app-account-query-action-form
                    *ngIf="action.actionTypeLabel === ActionTypeLabel.AC_QUER"
                    [subFormIsLoading$]="subFormIsLoading$"
                    [action]="action"
                    [form]="form"></app-account-query-action-form>

                <app-order-query-action-form
                    *ngIf="action.actionTypeLabel === ActionTypeLabel.ORD_QUER"
                    [subFormIsLoading$]="subFormIsLoading$"
                    [action]="action"
                    [form]="form"></app-order-query-action-form>

                <app-new-enquiry-action-form
                    *ngIf="action.actionTypeLabel === ActionTypeLabel.NEW_ENQ"
                    [subFormIsLoading$]="subFormIsLoading$"
                    [action]="action"
                    [form]="form"></app-new-enquiry-action-form>
            </div>
        </form>
    </div>

    <div
        *ngIf="resolutionScreen && form"
        class="resolution-block-holder">
        <div class="admin-selector-holder">
            <app-user-multi-select-area
                [preselectedUserIds]="data.action.taggedAdminsIds"
                [title]="'Tag Admin Users:'"
                (usersSelected)="userSelected($event)"></app-user-multi-select-area>
        </div>
        <form [formGroup]="form">
            <label class="padded-top-gray-label">Resolution:</label>
            <textarea
                class="textarea-styled"
                formControlName="resolution"
                rows="4"
                placeholder="Enter Resolution">
            </textarea>
        </form>
    </div>

    <div
        *ngIf="action.id && notes"
        class="action-comments-block">
        <div class="action-notes-top">
            <label class="padded-top-gray-label">Notes:</label>
            <div class="action-notes-button-holder">
                <button
                    type="button"
                    class="btn-styled"
                    (click)="addNote()">
                    <svg-icon
                        src="assets/images/buttons/plus-icon.svg"
                        [class]="'btn-svg-icon'"
                        [svgClass]="'icon--button'"></svg-icon>
                    Add Comment
                </button>
            </div>
        </div>
        <div class="lead-notes-body-holder">
            <div class="lead-notes-body styled-scrolled">
                <ng-container *ngIf="!notes.length">
                    <div class="lead-notes-empty">No Comments</div>
                </ng-container>
                <ng-container *ngIf="notes.length">
                    <div
                        class="lead-note-row"
                        *ngFor="let note of notes">
                        <app-action-note [note]="note"></app-action-note>
                    </div>
                </ng-container>
            </div>
        </div>
    </div>
</div>

<div class="action-buttons-holder">
    <button
        class="btn-styled--secondary"
        (click)="close()">
        Cancel
    </button>
    <button
        *ngIf="formStep === 1"
        class="btn-styled"
        [disabled]="nextStepDisabled"
        (click)="goToNextFormStep()">
        Next
    </button>
    <button
        *ngIf="formStep === 2"
        class="btn-styled"
        [disabled]="form?.invalid || (subFormIsLoading$ | async)"
        (click)="saveAction()">
        Save
    </button>
</div>

<app-confirmation
    *ngIf="updateCustomerConfirmationData.open"
    [data]="updateCustomerConfirmationData"
    (complete)="confirmAction($event)"></app-confirmation>

<app-note-form
    [recordId]="action.id"
    [type]="NoteType.Action"
    (noteAdded)="noteAdded($event)"></app-note-form>
